import axios from "../../../../utils/request"

function GET_LIST(params) {
    return axios.get("/ai/AGoogleAdsLoadingPageInstructions/list", {
        params: {
            ...params
        }
    } )
}
function EDIT_DATA(params) {
    return  axios.get("/ai/AGoogleAdsLoadingPageInstructions/info", {
        params:{
            ...params
        }
    })
}
function SUBMIT_ADD(params) {
    return  axios.post("/ai/AGoogleAdsLoadingPageInstructions/addPost",{...params} )
}
function SUBMIT_EDIT(params) {
    return  axios.post("/ai/AGoogleAdsLoadingPageInstructions/editPost",{...params} )
}


function CHANG_STATUS (params) {
    return  axios.post("/ai/AGoogleAdsLoadingPageInstructions/editStatus",{...params} )
}

export default {
    GET_LIST,
    SUBMIT_ADD,
    SUBMIT_EDIT,
    CHANG_STATUS,
    EDIT_DATA
}
